import React from 'react';
import { Link } from 'react-router-dom';
import { IconMail, IconBrandInstagram, IconBrandFacebook, IconBrandYoutube } from '@tabler/icons-react';
import { DateTime } from 'luxon';

const Footer = () => {
  const currentYear = DateTime.now().year;

  return (
    <footer className="uu-footer">
      <section className="uu-footer-container">
        <section className="uu-footer-main">
          <section className="uu-footer-brand">
            <img src="/UBUnitedlogoupdated.png" alt="UBunited Logo" className="uu-footer-logo" />
            <p className="uu-footer-tagline">
              Your pickleball community hub for rules, training, gear, and connection.
            </p>
          </section>

          <section className="uu-footer-links">
            <section className="uu-footer-column">
              <h3 className="uu-footer-title">Navigate</h3>
              <Link to="/" className="uu-footer-link">Pickleball</Link>
              <Link to="/blog" className="uu-footer-link">Blog</Link>
              <Link to="/videos" className="uu-footer-link">Videos</Link>
            </section>

            <section className="uu-footer-column">
              <h3 className="uu-footer-title">Resources</h3>
              <Link to="/resources/rules" className="uu-footer-link">Rules</Link>
              <Link to="/resources/governing-bodies" className="uu-footer-link">Governing Bodies</Link>
              <Link to="/resources/competitions" className="uu-footer-link">Competitions</Link>
            </section>

            <section className="uu-footer-column">
              <h3 className="uu-footer-title">Community</h3>
              <Link to="/messaging" className="uu-footer-link">Messaging</Link>
              <Link to="/groups" className="uu-footer-link">Groups</Link>
              <Link to="/shop" className="uu-footer-link">Shop</Link>
              <Link to="/about" className="uu-footer-link">About</Link>
              <Link to="/contact" className="uu-footer-link">Contact</Link>
            </section>

            <section className="uu-footer-column">
              <h3 className="uu-footer-title">Connect</h3>
              <a href="mailto:support@ubsports.com" className="uu-footer-contact">
                <IconMail size={16} stroke={2} />
                <span>support@ubsports.com</span>
              </a>
              <section className="uu-footer-social">
                <a href="#" aria-label="Instagram"><IconBrandInstagram size={20} stroke={2} /></a>
                <a href="#" aria-label="Facebook"><IconBrandFacebook size={20} stroke={2} /></a>
                <a href="#" aria-label="YouTube"><IconBrandYoutube size={20} stroke={2} /></a>
              </section>
            </section>
          </section>
        </section>

        <section className="uu-footer-legal-links">
          <Link to="/terms" className="uu-footer-link">Terms of Service</Link>
          <Link to="/privacy" className="uu-footer-link">Privacy Policy</Link>
          <Link to="/community-guidelines" className="uu-footer-link">Community Guidelines</Link>
        </section>

        <section className="uu-footer-bottom">
          <section className="uu-footer-powered">
            <span>Powered by</span>
            <a href="https://ubsports.com" target="_blank" rel="noopener noreferrer">
              <img src="/blackUbsportsLogo.png" alt="UBsports" className="uu-powered-logo" />
            </a>
          </section>
          <p className="uu-footer-copyright">
            &copy; {currentYear} UBunited. All rights reserved.
          </p>
        </section>
      </section>
    </footer>
  );
};

export default Footer;
